// Written by desktop/scripts/stamp-version.js. Do not edit by hand.
export const VERSION = "0.9.247";
export const BUILT_AT = "5 nov 01:13";
export const BUILT_AT_ISO = "2026-11-05T00:13:10.405Z";
